import iamAPI from "../../api/iamAPI";
import { urlContexts } from "../../constants";

export const selectTenant = async (token: string, tenantId: string, roleId?: string | undefined) => {
  const { data } = await iamAPI.post(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/auth/select-tenant`,
    { tenantId,
      roleId
     },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  );

  return data;
};
export const selectApplication = async (token: string, tenantId: string, appId: string) => {
  const { data } = await iamAPI.post(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/auth/select-application`,
    { tenantId, appId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  );

  return data;
};

export const selectRole = async (token: string, tenantId: string, appId: string, roleId: string, segment: string, env: string) => {
  const { data } = await iamAPI.post(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/auth/select-role`,
    { tenantId, appId, roleId, segment, env },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  );

  return data;
};